export function debounce(func, time: number)
{
    let offset = time || 100; // 100 by default if no param
    let timer;
    return function(event: Event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func, offset, event);
    };
}
